import axios from 'axios'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getAppVersionList(data) {
  return request({ url: '/admin/appVersion/list', method: 'post', data })
}

export function uploadAppVersionFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return axios.post(process.env.VUE_APP_BASE_API + '/admin/appVersion/upload', formData, {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.data.code !== 0) {
      throw new Error(res.data.message || '上传失败')
    }
    return res.data
  })
}

export function createAppVersion(data) {
  return request({ url: '/admin/appVersion/create', method: 'post', data })
}

export function updateAppVersion(data) {
  return request({ url: '/admin/appVersion/update', method: 'post', data })
}

export function deleteAppVersion(data) {
  return request({ url: '/admin/appVersion/delete', method: 'post', data })
}
